module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/90/assets/images/95b26a94ecab58e033e9f8d22f355b55.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Legend/Legend0.svg
// module id = P6IG
// module chunks = 1